export const SERVICES_CONSTS = {
    SET_SERVICES_DATA:"SET_SERVICES_DATA",
    CREATE_SERVICE_ITEM:"CREATE_SERVICE_ITEM",
    UPDATE_SERVICE_ITEM: "UPDATE_SERVICE_ITEM",
    DELETE_SERVICE_ITEM: "DELETE_SERVICE_ITEM",
    UPDATE_SERVICES_POSITIONS: "UPDATE_SERVICES_POSITIONS",
};
